export default "__VITE_ASSET__40ee6f8a__"